function IconSimpleAt({ fill, stroke }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 10H7C8.65685 10 10 8.65685 10 7V4H7C5.34315 4 4 5.34315 4 7V10Z" fill={fill} />
      <path d="M10 7V4H7C5.34315 4 4 5.34315 4 7V10H7C8.65685 10 10 8.65685 10 7V7ZM10 7V13V13C11.6569 13 13 11.6569 13 10V1H7C3.68629 1 1 3.68629 1 7V13H7" stroke={stroke} />
    </svg>
  )
}

export default IconSimpleAt